import React, { useCallback } from 'react';
import { IconButton } from './IconButton';
import { FilePlaceholder } from './FilePlaceholder';
import { CloseIcon } from './CloseIcon';
export var Thumbnail = function (_a) {
    var image = _a.image, _b = _a.size, size = _b === void 0 ? 100 : _b, handleClose = _a.handleClose, alt = _a.alt;
    var onClose = useCallback(function (event) { return handleClose === null || handleClose === void 0 ? void 0 : handleClose(event); }, [handleClose]);
    return (React.createElement("div", { className: "rfu-thumbnail__wrapper", style: { width: size, height: size } },
        React.createElement("div", { className: "rfu-thumbnail__overlay" }, handleClose ? (React.createElement(IconButton, { onClick: onClose },
            React.createElement(CloseIcon, null))) : null),
        image ? (React.createElement("img", { src: image, className: "rfu-thumbnail__image", alt: alt !== null && alt !== void 0 ? alt : '' })) : (React.createElement(FilePlaceholder, { preserveAspectRatio: "xMinYMin slice", className: "rfu-thumbnail__image" }))));
};
